import ApiClient from '../ApiClient';

class WizardBulkActionsAPI extends ApiClient {
  constructor() {
    super('wizard/bulk_actions', { accountScoped: true });
  }
}

export default new WizardBulkActionsAPI();
